import subjectFiltersSignal, {
	setSubjectFilters,
} from '@UI/Pages/Subjects/SubjectList/Filters/Signals/subjectFiltersSignal';
import type SubjectFieldDefinitionView from '@UI/Store/SubjectTypes/Views/SubjectFieldDefinitionView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { MultiSelect } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

type Props = {
	readonly definition: SubjectFieldDefinitionView;
	readonly withLabel?: boolean;
};

/** Filters the list on the options of a `choice` or `multiple_choice` field. */
const ChoiceFieldFilter: React.FC<Props> = ({ definition, withLabel = false }) => {
	const currentFilters = useSignalValue(subjectFiltersSignal);

	const handleChange = React.useCallback(
		(selection: readonly string[]) => {
			setSubjectFilters(subjectFiltersSignal.peek().setFieldValues(definition.key, selection));
		},
		[definition.key],
	);

	return (
		<MultiSelect<string>
			name={`subjectField-${definition.key}`}
			label={definition.label}
			isLabelHidden={!withLabel}
			placeholder={definition.label}
			options={definition.options}
			optionLabel="label"
			optionValue="value"
			value={currentFilters.valuesOf(definition.key)}
			onChange={handleChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default ChoiceFieldFilter;
